import React from 'react';
import { Modal as AntModal } from 'antd';
import style from './modal.module.scss';
import CloseIcon from '../../../../../assets/svg/solo-chat/circle-cross.svg';
import { LoadingIcon } from '../icons/LoadingIcon';
import { usePermissions } from '../hooks';

type Props = {
	children: React.ReactNode;
	isOpen: boolean;
	onOk: () => void;
	onCancel: () => void;
	title: string;
	okText: string;
	styles?: Record<string, string>;
	loading?: boolean;
	hideFooter?: boolean
};

export function Modal(props: Props) {
	const canEdit = usePermissions('content.Edit')

	const {
		isOpen,
		onOk,
		onCancel,
		title,
		children,
		okText,
		styles = {},
		loading = false,
		hideFooter = false,
	} = props;

	const modalStyles: any = {
		'--modal-max-width': '633px',
	};

	return (
		<div onClick={e => e.stopPropagation()}>
			<AntModal
				className="solo-chat-overrides"
				destroyOnClose
				style={{ ...modalStyles, ...styles }}
				footer={false}
				closable={false}
				visible={isOpen}
				onOk={onOk}
				onCancel={onCancel}
			>
				<div>
					<div className={style.modalHeader}>
						<p>{title}</p>
						<button onClick={onCancel}>
							<img src={CloseIcon} alt="close" />
						</button>
					</div>
					{children}
					{!hideFooter && (
						<div className={style.modalFooter}>
							<button className={style.cancelBtn} onClick={onCancel}>
								Cancel
							</button>
							{(okText !== 'Edit' || okText === 'Edit' && canEdit) &&
								<button
									data-loading={loading}
									className={style.okBtn}
									onClick={() => {
										if (!loading) {
											onOk();
										}
									}}
								>
									<span>{okText}</span>
									{loading && <LoadingIcon width="14" height="14" stroke="#FFF" />}
								</button>
							}
						</div>
					)}
				</div>
			</AntModal>
		</div>
	);
}
